<template>
  <div class="error-containter">
    <div class="error-message-container">
      <error-logo alt="error" aria-hidden="true"></error-logo>
      <div class="content">
        <div class="title">
          {{ $t("error_title") }}
        </div>
        <div class="message">
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorLogo from "@/assets/es.svg";
export default {
  name: "CertFullPageError",
  props: {
    message: String,
  },
  components: {
    ErrorLogo,
  },
};
</script>

<style lang="scss" scoped>
.error-containter {
  display: flex;
  align-items: center;
  height: 100%;

  .error-message-container {
    flex: 1;
    text-align: center;
    @include fontSize(14px);
    color: $exBlack;

    svg {
      width: 270px;
    }

    .title {
      margin-top: 24px;
      font-weight: bold;
    }
  }
}
</style>
